module.exports = require('./helpers/bundle-url').getBundleURL('cgEes') + "logo-dark.ba5147f0.svg";